export default __webpack_public_path__ + "static/media/codered_mobile.595d10be.png";